import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { bulkCancelFlashDiscount, bulkCancelFlashDiscountMutationKey, IBulkCancelFlashDiscountBody, IBulkCancelFlashDiscountResponse } from '../api/bulk-cancel-flash-discount';

export default function useBulkCancelFlashDiscount(
  options?: Pick<UseMutationOptions<IBulkCancelFlashDiscountResponse, any, IBulkCancelFlashDiscountBody, any>, 'onSuccess' | 'onError' | 'onSettled' | 'onMutate'>,
) {
  return useMutation({
    mutationKey: bulkCancelFlashDiscountMutationKey(),
    mutationFn: bulkCancelFlashDiscount,
    onSuccess: (data, variables, context) => {
      options?.onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context);
    },
    onSettled: (data, error, variables, context) => {
      options?.onSettled?.(data, error, variables, context);
    },
    onMutate: (variables) => {
      options?.onMutate?.(variables);
    },
    retry: false,
  });
}
